import { Component } from 'react';
import styled, { css } from 'styled-components';
import { Position } from '../../../../../../../domain/model/notice/INoticeRepository';
import NoticeHelper from '../../../../../common/helper/NoticeHelper';
import NoticeContents from './NoticeContents';

export interface INoticePc {
  type: 'announce' | 'mediatag';
  mediaTagId?: string;
  priority: number;
  createTime: string;
  startTime: string;
  contents: Array<{
    contentId: number;
    title: string;
    description?: string;
    linkUrl?: string;
    imageUrl?: string;
    pos?: number;
  }>;
}
interface IProps {
  notices: Array<INoticePc>;
  position: Position;
  ultSec: string;
}

const Wrapper = styled.div<{ $position: IProps['position'] }>`
  ${({ $position }) =>
    $position === Position.MAIN_TOP
      ? css`
          /* メインカラムお知らせ */
          padding: 12px 16px;
          background-color: ${props => props.theme.news.palette.bg_lv1_common};
        `
      : css`
          /* サブカラムお知らせ */
          padding-bottom: 16px;
          border-top: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
        `}
`;

export default class Notice extends Component<IProps> {
  /**
   *
   */
  public render() {
    if (this.props.notices.length === 0) {
      return null;
    }
    // お知らせの並びをソートし、リンクがあるお知らせのみposを追加
    const sortedNotice = NoticeHelper.sortNoticePC(this.props.notices);
    const addedPosNotice = NoticeHelper.addPosNoticePC(sortedNotice);
    const notices = addedPosNotice.map((notice, index) => {
      return (
        <NoticeContents
          {...notice}
          position={this.props.position}
          index={index}
          key={`${this.props.position}_${index}`}
          rsec={this.props.ultSec}
        />
      );
    });
    return <Wrapper $position={this.props.position}>{notices}</Wrapper>;
  }
}
